export default __webpack_public_path__ + "static/media/receiver-grey.c54f4dcd.svg";